/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import ExternalLinksWrapper from 'bundles/assess-common/components/ExternalLinksWrapper';
import type { UrlSubmissionPartResponse } from 'bundles/compound-assessments/components/api/types/CompoundAssessmentsForm';
import EmbeddedContent from 'bundles/compound-assessments/components/shared/embeddedContent/EmbeddedContent';

import _t from 'i18n!nls/compound-assessments';

type Props = {
  submissionPart: UrlSubmissionPartResponse;
};

const styles = {
  noUrlMessage: () => css`
    color: var(--cds-color-grey-600);
  `,
};

export const UrlView = (props: Props) => {
  const { submissionPart } = props;
  return (
    <ExternalLinksWrapper>
      {submissionPart.url ? (
        <EmbeddedContent url={submissionPart.url} title={submissionPart.title || submissionPart.url} />
      ) : (
        <Typography2 component="p" variant="bodyPrimary" css={styles.noUrlMessage}>
          {_t('No URL provided')}
        </Typography2>
      )}

      <Typography2 component="p" variant="bodyPrimary">
        {submissionPart.caption}
      </Typography2>
    </ExternalLinksWrapper>
  );
};

export default UrlView;
